<template>
    <div class="option-plans-popup m-0" :class="openOptionPlans">
        <pricing-table textBtn="Seleccionar" :isRegister="false" :compact="true"></pricing-table>
    </div>
    <div :class="background">
        <div class="clients" :class="classClient">
            <div v-if="isShowContact" class="menu-container">
                <div class="user-info">
                    <div class="w-50" v-if="contacts.length > 0">
                        <div id="" @click="showPrintOption()">
                            <span class="btn btn-secondary btn-sm badge rounded-pill bg-green">Imprimir Fichas <i class="las la-print"></i></span>
                        </div>
                        <div class="print-options" v-show="showHidePrintOption">
                            <!-- show soport -->
                            <ul>
                                
                                <li>
                                    <a href="#" @click="printRecords('')">
                                        <i class="las la-file-pdf"></i> Descargar PDF
                                    </a>
                                </li>
                                <li>
                                    <a href="#" @click="downloadExcelContacts('')">
                                        <i class="las la-file-csv text-green"></i> Descargar Excel
                                    </a>
                                </li>
                                
                            </ul>
                        </div>
                       
                       
                    </div>
                    <div class="user text-white" @click="addNewUser()" v-if="!isNewUser || !isEdition">
                        <i class="las la-plus new-clients"></i> <small>Agregar</small>
                    </div>
                </div>
                <div class="search-contact">
                    <div>
                        <i class="las la-search"></i>
                        <input type="text" placeholder="Buscar contacto" v-model="searchContact" @keyup="liveSearch()" />
                    </div>
                </div>
                <div class="list-contact" v-if="contacts.length > 0">
                    <div class="contact" v-for="c in contacts" :key="c.idSeller" @click="openContact(c.idSeller, c.imgSeller, c.sellerName, c.idChat)" :data-search-term="c.sellerName.toLowerCase()">  
                        <img v-if="c.imgSeller == '@/assets/imgs/user-img-small.png'" src="@/assets/imgs/user-img-small-gradient.png" />
                        <img v-else :src="c.imgSeller" />
                        <div>
                        {{c.sellerName}}
                        </div>
                    </div> 
                </div>
            </div>

            <div class="ficha text-muted">
                <div class="d-flex h-100 justify-content-center align-items-center" v-if="!isActiveclients">
                    <div class="w-25 text-center" v-if="displayInitialText != 'none'">
                     <p class="text-muted">Ficha de tus clientes dentro de la plataforma.</p>
                    </div>
                </div>
                <div class="user-info text-white" v-if="isActiveclients">
                    <div v-if="nameTo != ''">
                        <i class="las la-arrow-left close text-white me-2" @click="showContactsMenu(); closeEdition(); closeAddContact()"></i>
                    </div>
                    <div v-show="isShowContact" class="user flex-fill" v-if="nameTo != ''">
                        <img v-if="avatarTo != '@/assets/imgs/user-img-small.png'" :src="avatarTo" />
                        <img v-else src="@/assets/imgs/user-img-small.png" />
                        {{nameTo}}
                    </div>
                    <div class="d-none d-md-block option-scroll m-0 w-auto" v-if="!isNewUser">
                        <div class="option-scroll-container">
                            <button class="btn btn-light" v-if="contactsInfo" @click="changeTab('user-information')">Info</button>
                            <!--<button class="btn btn-light" @click="changeTab('psicoHistory')">Apuntes</button>-->
                            <button class="btn btn-light" v-if="contactsClinic" @click="changeTab('clinicHistory')">H. Clínica</button>
                            <button class="btn btn-light" v-if="contactsBilling" @click="changeTab('balances')">Contrataciones</button>
                            <button v-show="showChat && contactsChat" class="btn btn-light" @click="goToAction(this.chatId, 'chat')">Chat</button>
                        </div>
                    </div>
                    
                </div>
                <div class="clients-users" v-show="isActiveclients">
                    <div class="d-block d-md-none option-scroll" v-if="!isNewUser">
                        <div class="option-scroll-container">
                            <button class="btn btn-primary" v-if="contactsInfo" @click="changeTab('user-information')">Info</button>
                            <!--<button class="btn btn-primary" @click="changeTab('psicoHistory')">Apuntes</button>-->
                            <button class="btn btn-primary" v-if="contactsClinic" @click="changeTab('clinicHistory')">H. Clínica</button>
                            <button class="btn btn-primary" v-if="contactsBilling" @click="changeTab('balances')">Contrataciones</button>
                            <button v-show="showChat && contactsChat" class="btn btn-primary" @click="goToAction(this.chatId, 'chat')">Chat</button>
                        </div>
                    </div>

                    <div id="editUserInfo" class="d-block justify-content-center align-items-center pb-5 mb-5" :class="isNewUserClass" v-show="isNewUser">
                        <form @submit.prevent="addContact" class="text-secondary">
                            <div class="container justify-content-md-center text-center"> 
                                <div class="row pt-3">
                                    <div class="col-md-12">
                                        <p class="small fc-italic text-green mt-3" v-show="!isEdition">Agrega un nuevo usuario a tus contactos.</p>
                                    </div>
                                    <div class="col-md-6">
                                        <i v-show="!isEdition" class="las la-user-circle icon-decoration"></i>
                                        <div v-if="isEdition">
                                            <label>Email del usuario:</label>    
                                            <div class="input-group mb-3">
                                                <input type="email" class="form-control form-control-lg" attr-id="userMail" v-model="userMail" autocomplete="new-userMail">    
                                            </div>
                                        </div>
                                        
                                        <label class="text-secondary">Whatsapp del usuario:</label>    
                                        <div class="input-group mb-3">  
                                            <input-phone-login v-if="isNewUser || isEdition" :phoneShow="userPhone" :showLabel="false" class="w-100"></input-phone-login>     
                                        </div>

                                        <label class="text-secondary">Nombre:</label>    
                                        <div class="input-group mb-3">
                                            <input type="text" class="form-control form-control-lg" attr-id="userName" v-model="userFirstName" autocomplete="new-userName">     
                                        </div>
                                        <label class="text-secondary">Apellido:</label> 
                                        <div class="input-group mb-3">
                                            <input type="text" class="form-control form-control-lg" attr-id="userLastName" v-model="userLastName" autocomplete="new-userLastName">     
                                        </div>
                                        <div class="row mb-3" v-show="isEdition">
                                            <div class="col-xs-12">
                                                <label class="text-secondary">Fecha de Nacimiento:</label> 
                                            </div>
                                            <div class="col-12" v-if="$route.params.browserCountry == 'us'">
                                                <div class="row p-3 pt-0 pb-0">
                                                    <div class="col-4 p-0">
                                                        <div class="input-group">
                                                            <select class="form-control form-control-lg text-center" attr-id="userMonth" v-model="userMonth" autocomplete="new-userMonth">
                                                                <option v-for="n in 12" :value="('0' + n).slice(-2)" :key='n'>{{ ('0' + n).slice(-2) }}</option>
                                                            </select>  
                                                        </div>
                                                    </div>
                                                    <div class="col-4 p-0">
                                                        <div class="input-group">
                                                            <select class="form-control form-control-lg text-center" attr-id="userDay" v-model="userDay" autocomplete="new-userDay">
                                                                <option v-for="n in 31" :value="('0' + n).slice(-2)" :key='n'>{{ ('0' + n).slice(-2) }}</option>
                                                            </select>    
                                                        </div>
                                                    </div>
                                                    <div class="col-4 p-0">
                                                        <div class="input-group">
                                                            <select class="form-control form-control-lg text-center m-0" attr-id="userYear" v-model="userYear" autocomplete="new-userYear">
                                                                <option v-for="year in years" :value="year" :key="year">{{ year }}</option>
                                                            </select>  
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12" v-else>
                                                <div class="row p-3 pt-0 pb-0">
                                                    <div class="col-4 p-0"> 
                                                        <div class="input-group">
                                                            <select class="form-control form-control-lg text-center" attr-id="userDay" v-model="userDay" autocomplete="new-userDay">
                                                                <option v-for="n in 31" :value="('0' + n).slice(-2)" :key='n'>{{ ('0' + n).slice(-2) }}</option>
                                                            </select>    
                                                        </div>
                                                    </div>
                                                    <div class="col-4 p-0">
                                                        <div class="input-group">
                                                            <select class="form-control form-control-lg text-center" attr-id="userMonth" v-model="userMonth" autocomplete="new-userMonth">
                                                                <option v-for="n in 12" :value="('0' + n).slice(-2)" :key='n'>{{ ('0' + n).slice(-2) }}</option>
                                                            </select>  
                                                    </div>
                                                    </div>
                                                    <div class="col-4 p-0">
                                                        <div class="input-group">
                                                            <select class="form-control form-control-lg text-center m-0" attr-id="userYear" v-model="userYear" autocomplete="new-userYear">
                                                                <option v-for="year in years" :value="year" :key="year">{{ year }}</option>
                                                            </select>  
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row mb-3" v-if="isEdition && profCountry == 5 && userCountry == 5">
                                            <div class="col-12">
                                                <div class="row p-3 pt-0 pb-0">
                                                    <div class="col-md-6 p-0">      
                                                        <label>Obra Social / Prepaga:</label> 
                                                        <div class="input-group mb-3">
                                                            <input type="text" class="form-control form-control-lg text-start" attr-id="obraSocial" v-model="obraSocial" autocomplete="new-obraSocial">     
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 p-0">
                                                        <label>Afiliado N°:</label> 
                                                        <div class="input-group mb-3">
                                                            <input type="text" class="form-control form-control-lg text-start" attr-id="numObraSocial" v-model="numObraSocial" autocomplete="new-numObraSocial">     
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>           
                                        </div> 
                                    </div>
                                    <div class="col-md-6">
                                        <label class="text-secondary">País:</label>    
                                        <div class="input-group mb-3">
                                            <select class="form-control form-control-lg text-center m-0" attr-id="userCountry" v-model="userCountry" @change="findStates(); userState = ''; userCity = '';" autocomplete="new-userCountry">
                                            </select>    
                                        </div>
                                        <label>Provincia/Estado:</label> 
                                        <div class="input-group mb-3">
                                            <select class="form-control form-control-lg text-center m-0" attr-id="userState" v-model="userState" @change="findCities(); userCity = '';" autocomplete="new-userState">
                                                <option v-for="n in 12" :value="('0' + n).slice(-2)" :key='n'>{{ ('0' + n).slice(-2) }}</option>
                                            </select>       
                                        </div>
                                        <div v-if="!isEdition">
                                            <label>Email del usuario:</label>    
                                            <div class="input-group mb-3">
                                                <input type="email" class="form-control form-control-lg" attr-id="userMail" v-model="userMail" autocomplete="new-userMail">    
                                            </div>
                                        </div>
                                        
                                        <div v-show="isEdition"> 
                                            <label>Ciudad:</label> 
                                            <div class="input-group mb-3">
                                                <select class="form-control form-control-lg text-center m-0" attr-id="userCity" v-model="userCity" autocomplete="new-userCity">
                                                    <option v-for="n in 12" :value="('0' + n).slice(-2)" :key='n'>{{ ('0' + n).slice(-2) }}</option>
                                                </select>       
                                            </div>      
                                            <label>Dirección:</label> 
                                            <div class="input-group mb-3">
                                                <input type="text" class="form-control form-control-lg" attr-id="userStreet" v-model="userStreet" autocomplete="new-userStreet">     
                                            </div>
                                            <div class="row mb-3">
                                                <div class="col-12">
                                                    <div class="row p-3 pt-0 pb-0">
                                                        <div class="col-4 p-0">      
                                                            <label>Piso:</label> 
                                                            <div class="input-group mb-3">
                                                                <input type="text" class="form-control form-control-lg text-center me-2" attr-id="userFloor" v-model="userFloor" autocomplete="new-userFloor">     
                                                            </div>
                                                        </div>
                                                        <div class="col-8 p-0">
                                                            <label>Depto:</label> 
                                                            <div class="input-group mb-3">
                                                                <input type="text" class="form-control form-control-lg text-center" attr-id="userDepto" v-model="userDepto" autocomplete="new-userDepto">     
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>           
                                            </div> 
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-center align-items-center" v-if="isEdition">
                                    <div class="mt-1 text-start">
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" value="1" checked v-model="userGender">
                                            <label class="form-check-label" for="flexRadioDefault1">
                                                <i class="las la-mars"></i> Hombre
                                            </label>
                                        </div>
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" value="2" v-model="userGender">
                                            <label class="form-check-label" for="flexRadioDefault2">
                                                <i class="las la-venus"></i> Mujer
                                            </label>
                                        </div>
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" value="3" v-model="userGender">
                                            <label class="form-check-label" for="flexRadioDefault2">
                                                <i class="las la-transgender"></i> Otro
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-3 d-grid gap-2 col-12 mx-auto pb-3 pt-3">
                                    <button v-show="isEdition" class="btn btn-primary" type="submit" :disabled="disabled"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span> Actualizar</button>
                                    <button v-show="!isEdition" class="btn btn-primary" type="submit" :disabled="disabled"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span> Agregar</button>
                                    <button v-show="isEdition" class="btn btn-secondary" type="button" @click="closeEdition()">Cancelar</button>
                                    <button v-if="!isEdition" class="btn d-none d-sm-block btn-secondary" type="button" @click="closeAddContact()">Cancelar</button>
                                    <button v-if="!isEdition" class="btn d-block d-sm-none btn-secondary" type="button" @click="closeAddContact(); showContactsMenu();">Cancelar</button>
                                </div>  
                            </div>
                        </form> 
                    </div>
                    <div v-show="tabList == 'user-information'" class="text-secondary">
                        <div class="user-Info pb-5 mb-5">
                            <div class="row">
                                <div class="col-md-4 text-center">
                                    <img v-if="userImg != '@/assets/imgs/user-img-small.png'" :src="userImg" class="img-fluid img-user rounded-img-bordered" />
                                    <img v-else src="@/assets/imgs/user-img-small-gradient.png" class="img-fluid rounded-img-bordered" />
                                </div>
                                <div class="col-md-8">
                                    
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h3 class="title fw-light text-secondary">Información Personal</h3>
                                            <div class="title">
                                                <a class="text-primary pointer p-1" @click="editUserInfo()">Editar Datos</a>
                                                <a v-if="isShowContact" class="text-primary pointer text-danger p-1" @click="deleteContact()">Eliminar</a>
                                            </div>
                                            <div class="title mt-3">
                                                <span class="btn btn-secondary btn-sm badge rounded-pill bg-green w-50 mx-auto" @click="printRecords(this.chatId)">Imprimir Ficha <i class="las la-print"></i></span>
                                            </div>
                                            <hr>
                                            <p class="m-0"><b>Nombre:</b></p>
                                            <h6 class="fw-light">{{userFirstName}} {{userLastName}}</h6>
                                            <h6 class="fw-light">{{userGenderText}}</h6>
                                            <hr>
                                        </div>   
                                        <div class="col-md-6">
                                            <p class="m-0"><b>Teléfono:</b></p>
                                            <h6 class="fw-light" v-if="userPhone != ''"><a class="text-primary" target="blank" :href="'https://api.whatsapp.com/send?phone='+showPhone">{{userPhone}}</a></h6>
                                            <h6 class="fw-light" v-else>-----------</h6>
                                            <hr>
                                        </div>
                                        <div class="col-md-6">
                                            <p class="m-0"><b>Email:</b></p>
                                            <h6 class="fw-light" v-if="userMail != ''"><a class="text-primary" target="blank" :href="'mailto:'+userMail">{{userMail}}</a></h6>
                                            <h6 class="fw-light" v-else>-----------</h6>
                                            <hr>
                                        </div>

                                        <div class="col-md-6">
                                            <p class="m-0"><b>Obra Social / Prepaga:</b></p>
                                            <h6 class="fw-light" v-if="obraSocial != ''">{{obraSocial}}</h6>
                                            <h6 class="fw-light" v-else>-----------</h6>
                                            <hr>
                                        </div>
                                        <div class="col-md-6">
                                            <p class="m-0"><b>Afiliado N°:</b></p>
                                            <h6 class="fw-light" v-if="numObraSocial != ''">{{ numObraSocial }}</h6>
                                            <h6 class="fw-light" v-else>-----------</h6>
                                            <hr>
                                        </div>

                                        <div class="col-md-6">
                                            <p class="m-0"><b>Fecha de nacimiento:</b></p>
                                            <h6 class="fw-light" v-if="userBirthDate != ''">{{userBirthDate}}</h6>
                                            <h6 class="fw-light" v-else></h6>
                                            <hr class="d-block d-sm-none">
                                        </div>
                                        <div class="col-md-6">
                                            <p class="m-0"><b>Dirección:</b></p>
                                            <h6 class="fw-light" v-if="userAddress != ''">{{userAddress}}</h6>
                                            <h6 class="fw-light" v-else></h6>
                                        </div>
                                    </div>    
                                </div>
                                <div class="col-md-12">
                                    <h3 class="title fw-light text-center">Notas adicionales:</h3>
                                    <div class="input-group mb-3">
                                        <textarea class="form-control form-control-lg" v-model="notes" rows="5" cols="10" placeholder="Puedes escribir aquí cualquier información adicional sobre el usuario."></textarea>   
                                    </div>
                                    <div class="text-center">
                                        <button @click="saveNotes()" class="btn btn-primary mx-auto" type="submit" :disabled="disabled"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span> Guardar Notas</button>
                                    </div>
                                </div>
                            </div>
                        </div>     
                    </div>
                    <div class="mt-4 pb-5 mb-3" v-if="tabList == 'balances'">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-4">
                                    <balances-prof :userSelected="this.userSelected" userMode="1" showAll="false" textButton="Ingresar Pago" :hideDetails="false"></balances-prof>
                                    <div v-if="profCountry == 5 && userCountry == 5">
                                        <hr>
                                        <form-afip-data v-if="userSelected != ''" :userSelected="dataReceiver" :userMode="2" :generateKey="false" textButton="Guardar" :refContact="userSelected"></form-afip-data>    
                                    </div>
                                </div>    
                                <div class="col-md-8">    
                                    <professionals-records-sales v-if="items.length > 0" :result="items" :dataReceiver='dataReceiver' :consultantId="userSelected" :placeholder="'Buscar por publicación, fecha'" :sticky="'sticky'"></professionals-records-sales> 
                                </div>
                            </div>
                        </div>

                    </div>  
                    <div class="mt-4 pb-5 mb-3" v-if="tabList == 'psicoHistory'">
                        <psico-history v-if="userSelected != ''" :userId="dataReceiver" :consId="userSelected"></psico-history>
                    </div>
                    <div class="mt-4 pb-5 mb-3" v-if="tabList == 'clinicHistory'">
                        <history v-if="userSelected != ''" :userId="dataReceiver" :consId="userSelected"></history>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="mx-auto position-fixed bottom-0 end-0 start-0 end-0 p-0 pt-3 pb-3" style="z-index: 118; width: fit-content; margin-bottom: 50px;">
        <div id="toastcontainer" class="w-25">
        </div>
    </div>




    <div class="modal fade" id="modalDelete" tabindex="-1" aria-labelledby="" aria-hidden="true" ref="modalDelete">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title"></h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="text-dark">
                        <h6 class="text-primary mb-3"><i class="las la-bullhorn"></i> Eliminar Ficha</h6>
                        <p><i class="las la-circle text-primary"></i> Al eliminar la ficha no podrás acceder nuevamente a esta.</p>
                        <p><i class="las la-circle text-primary"></i> Ni tú ni el consultante podrán tampoco acceder al chat directo.</p>
                        <p><i class="las la-circle text-primary"></i> Igualmente seguirás viendo las reservas que tengas con el consultante.</p>
                        <p class="mt-3 text-center">¿Quieres eliminar la ficha?</p>
                        <div class="row">
                        <div class="mb-3 d-grid gap-2 col-12 mx-auto mt-3">
                            <button class="btn btn-secondary text-decoration-none text-white" data-bs-dismiss="modal" aria-label="Close">                           
                                Cancelar
                            </button>
                            <button class="btn btn-primary text-decoration-none text-white" @click="confirmDeleteContact()" data-bs-dismiss="modal" aria-label="Close">                           
                                Eliminar
                            </button> 
                        </div>
                    </div>  
                    </div>  
                </div>
                <div class="modal-footer"> 
                </div>
            </div>
        </div>
    </div> 
</template>
<script>
import inputPhoneLogin from '@/components/input-phone-login.vue';
import balancesProf from '@/components/dashboard/balances-prof.vue'
import pricingTable from '@/components/plans/pricing-table.vue'
import professionalsRecordsSales from '@/components/my-account/professionals-records-sales.vue'
import formAfipData from '@/components/my-account/form-afip-data.vue'
import psicoHistory from '@/components/clients/psico-history.vue'
import history from '@/components/clients/history/history.vue'
import axios from "axios";
import { Toast } from 'bootstrap'
import { Modal } from "bootstrap";
export default {    
    name: "records",
    props: ['showBackground', 'showContacts', 'openUser', 'showChat', 'classClient', 'displayInitialText'],
    components: {   
        inputPhoneLogin,
        balancesProf,
        pricingTable, 
        professionalsRecordsSales,
        formAfipData,
        psicoHistory,
        history
    },
    data(){
        return{

            bookingId: '',
            errorText: '',
            toastColor: '',
            toastBg: '',
            toastNumber: 0,
            background: this.showBackground,
            isShowContact: this.showContacts,
            showChat: this.showChat,
            isNewUser: false,
            isEdition: false,
            userCountry: '',
            userState: '',
            userCity: '',
            userStreet: '',
            userFloor: '',
            userDepto: '',
            userAddress: '',
            userPhone: '',
            showPhone: '',
            isPhone: 0,
            isNewUserClass: '',
            userIdentify: 'NGVCTkNwM0FVbHJpN3B1SUNIOHFoUT09',
            userFirstName: '',
            userLastName: '',
            userMail: '',
            userDay: '',
            userMonth: '',
            userYear: '',
            year: '',
            loading: false,
            disabled: false,
            tabList: '',
            classContainer: 'd-none',
            userSelected: '',
            userGenderText: '',
            userImg: '',
            userBirthDate: '',
            userGender: '',
            dataReceiver: '',
            contacts: [],
            searchContact: '',
            ficha: '',
            showTurns: 'next',
            nextclients: 0,
            endclients: 0,
            localZone: '',
            clients: [],
            me: '',
            to: '',
            avatarTo: '',
            nameTo: '',
            idLastclients: 0,
            bookings: [],
            bookingsLast: [],
            positionScroll: 0,
            isActiveclients: false,
            containerWrite: false,
            bookingsEnd: 0,
            bookingsEndLast: 0,
            next: 0,
            filter: 0,
            nextLast: 0, 
            chatId: '',
            notes: '',
            openOptionPlans: '',
            blockUse: false, 
            showHidePrintOption: false,
            items: [],
            profCountry: 0,
            obraSocial: '',
            numObraSocial: ''
        }
    },
    mounted: function () {  
        var element =  document.getElementById('momentScript');
        if (typeof(element) != 'undefined' && element != null){
            this.localZone =  moment.tz.guess();
            if (localStorage.getItem("corporativeIn") !== null && localStorage.getItem("corporativeIn") !== "") {
                this.dataReceiver = localStorage.getItem('corporativeIn');
            }else{
                this.dataReceiver = localStorage.getItem('token');
            }
            this.findContacts();         
            if(this.$route.params.ref){
                this.findContact(this.$route.params.ref);
            } 
            if(this.openUser){
                this.findContact(this.openUser);
            }
            this.findUserData(); 
        }else{       
            const plugin = document.createElement("script");
            plugin.setAttribute("src", "https://cdn.jsdelivr.net/npm/moment@2.27.0/min/moment.min.js");
            plugin.setAttribute("id", "momentScript");
            plugin.async = false;
            document.head.appendChild(plugin);
            const plugin2 = document.createElement("script");
            plugin2.setAttribute("src", "https://cdnjs.cloudflare.com/ajax/libs/moment-timezone/0.5.34/moment-timezone-with-data-10-year-range.js");
            plugin2.setAttribute("id", "momentScriptYears");
            plugin2.async = false;
            document.head.appendChild(plugin2);
            plugin.onload = () => {
                plugin2.onload = () => {
                    this.localZone =  moment.tz.guess();
                    if (localStorage.getItem("corporativeIn") !== null && localStorage.getItem("corporativeIn") !== "") {
                        this.dataReceiver = localStorage.getItem('corporativeIn');
                    }else{
                        this.dataReceiver = localStorage.getItem('token');
                    }
                    this.findContacts();         
                    if(this.$route.params.ref){
                        this.findContact(this.$route.params.ref);
                    } 
                    if(this.openUser){
                        this.findContact(this.openUser);
                    }
                    this.findUserData(); 
                }
            } 
        }
    },  
    computed :{
        years(){
            this.year = new Date().getFullYear()
            return Array.from({length: this.year - 1940}, (value, index) => this.year - index);
        },
        contactsInfo() {
            var show = true;
            if (localStorage.getItem("corporativeIn") !== null && localStorage.getItem("corporativeIn") !== "") {
                show = this.$root.corporatePermissions('contactsInfo');
            }
            return show
        },
        contactsNotes() {
            var show = true;
            if (localStorage.getItem("corporativeIn") !== null && localStorage.getItem("corporativeIn") !== "") {
                show = this.$root.corporatePermissions('contactsNotes');
            }
            return show
        },
        contactsClinic() {
            var show = true;
            if (localStorage.getItem("corporativeIn") !== null && localStorage.getItem("corporativeIn") !== "") {
                show = this.$root.corporatePermissions('contactsClinic');
            }
            return show
        },
        contactsBilling() {
            var show = true;
            if (localStorage.getItem("corporativeIn") !== null && localStorage.getItem("corporativeIn") !== "") {
                show = this.$root.corporatePermissions('contactsBilling');
            }
            return show
        },  
        contactsChat() {
            var show = true;
            if (localStorage.getItem("corporativeIn") !== null && localStorage.getItem("corporativeIn") !== "") {
                show = this.$root.corporatePermissions('contactsChat');
            }
            return show
        },
    },
    methods:{
        expandRecord(){
            const isMobile = window.innerWidth <= 768; // solo móviles
            if (!isMobile) return;

            const calContainer = document.querySelector('.clients-container');
            const footers = document.querySelectorAll('.foot-seller');
            const navs = document.querySelector('.nav-sticky');

            if (!calContainer) return;

            // Agregar clases mientras hay scroll válido

            calContainer.classList.add('clients-container-off');
            navs?.classList.add('nav-sticky-off');
            footers.forEach(f => f.classList.add('foot-seller-off'));
        },   
        contractRecord(){
            const isMobile = window.innerWidth <= 768; // solo móviles
            if (!isMobile) return;

            const calContainer = document.querySelector('.clients-container');
            const footers = document.querySelectorAll('.foot-seller');
            const navs = document.querySelector('.nav-sticky');


            if (!calContainer) return;

            calContainer.classList.remove('clients-container-off');
            navs?.classList.remove('nav-sticky-off');
            footers.forEach(f => f.classList.remove('foot-seller-off'));
        },  
        showPrintOption(){
            if(this.showHidePrintOption == false){
                this.showHidePrintOption = true;
                
            }else{
                this.showHidePrintOption = false;
              
            }
        },
        async deleteContact(){
            this.showHidePrintOption = false;
            try{
                var modal = new Modal(document.querySelector('#modalDelete'))
                modal.show();
            }catch(e){
                console.log(e)
            }
        },
        async confirmDeleteContact(){     
            this.$root.showWaiting('Aguarde...');
            var payload = {
                action: 'delete-contact',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.dataReceiver,
                ref: this.chatId      
            }     
            await axios.post('/index.php', payload).then(result => {
                this.$root.hideWaiting();
                if(result.data.status == '200'){
                    this.closeAddContact();
                    this.findContacts();
                    this.showContactsMenu();  
                    this.errorText = 'Contacto eliminado.';
                    this.toastBg = 'bg-info';
                    this.toastColor = 'text-dark';
                    this.toastNumber++;
                    var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                    try{
                        document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                        var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                        var bsAlert = new Toast(myAlert);//inizialize it
                        bsAlert.show();//show it
                    }catch(e){

                    }		
                }              
            })
            .catch(error => {
               
            })     
        },
        async printRecords(val){
            this.showHidePrintOption = false;
            this.$root.closePdf();
            this.$root.showWaiting('Generando archivo para imprimir...');
            var payload = {
                action: 'print-records',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.dataReceiver,
                ref: val      
            }       
            await axios.post('/index.php', payload).then(result => {
                this.$root.hideWaiting();
                if(result.data.status == '200'){
                    if(window.location.host == 'h.animasana.net' || window.location.host == 'animasana.net'){
                        this.$root.openPdf('https://api.animasana.net/' + result.data.file);  
                    }else if(window.location.host == 'api-qa.animasana.net'){   
                        this.$root.openPdf('https://api-qa.animasana.net/' + result.data.file);  
                    }else{        
                        this.$root.openPdf('https://api-qa.animasana.net/' + result.data.file);      
                    }
                }              
            })
            .catch(error => {
               
            })     
        }, 
        async downloadExcelContacts(){
            this.showHidePrintOption = false;
            this.$root.closePdf();
            this.$root.showWaiting('Generando archivo para descargar...');
            var payload = {
                action: 'download-excel-contacts',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.dataReceiver    
            }       
            await axios.post('/index.php', payload).then(result => {
                this.$root.hideWaiting();
                if(window.location.host == 'h.animasana.net' || window.location.host == 'animasana.net'){
                    this.download('https://api.animasana.net' + result.data.file, 'nombre.xlsx');  
                }else if(window.location.host == 'api-qa.animasana.net'){
                    this.download('https://api-qa.animasana.net' + result.data.file, 'nombre.xlsx');  
                }else{
                    this.download('https://api-qa.animasana.net' + result.data.file, 'nombre.xlsx'); 
                }
            })
            .catch(error => {
               
            })     
        }, 
        download(dataurl, filename) {
            const link = document.createElement("a");
            link.href = dataurl;
            link.download = filename;
            link.click();
        },
        async findUserData(){  
            this.showHidePrintOption = false;  
            var payload = {
                action: 'find-user-data',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.dataReceiver,      
            }       
            await axios.post('/index.php', payload).then(result => {
                if (localStorage.getItem("corporativeIn") !== null && localStorage.getItem("corporativeIn") !== "") {
                    var data = result.data;
                }else{
                    localStorage.setItem('userData', JSON.stringify(result.data)); 
                    var data = JSON.parse(localStorage.getItem('userData'));
                }   
                this.profCountry = data.userCountry
                this.blockUse =  data.blockUse; 
            })
            .catch(error => {
               
            })     
        },

        
        changeTurns(){
            if(this.showTurns == "next"){
                this.showTurns = "last";
            }else{
                this.showTurns = "next";
            }
        },
        closeOptions(){
            this.bookingId = '';
        },


        closeReset() {
            this.showHidePrintOption = false;
            this.changeTab('bookings');    
        },   
        changeTab(val){
            this.showHidePrintOption = false;
            
            this.tabList = val;
            if(val == 'bookings'){
                this.bankClass = '';
                this.bookingsEnd = 0;
                this.bookingsEndLast = 0;
                this.next = 0;
                this.filter = 0;
                this.nextLast = 0;
                this.bookingsLast = [];
                this.bookings = [];
                this.findBookingsNext();
                this.findBookingsLast();    
            }
        },
        addNewUser(){
            this.expandRecord();
            this.showHidePrintOption = false;
            var elems = document.querySelectorAll(".bad");
            [].forEach.call(elems, function(el) {
                el.classList.remove("bad");
            });
            this.avatarTo = '@/assets/imgs/user-img-small.png';
            this.tabList= '';
            this.userFirstName = '';
            this.userLastName = '';
            this.isPhone = '';
            this.userPhone = '';
            this.userCountry = '';
            this.userState = '';
            this.userCity = '';
            this.userStreet = '';
            this.userFloor ='';
            this.userDpto = '';
            this.userPObox = '';
            this.userGender = '';
            this.userMail = '';
            this.numObraSocial = '';
            this.obraSocial = ''; 
            this.isNewUserClass = 'new d-flex';
            this.isActiveclients = true;  
            this.isEdition = false;
            this.nameTo = 'Nuevo Cliente';
            document.querySelector('.menu-container').classList.add('hide');
            document.querySelector('.ficha').classList.add('show');
            this.isNewUser = true;  
            this.findCountries();  
            console.log('openFicha')     
        },
        closeAddContact(){
            console.log('closeFicha')
            this.showHidePrintOption = false;
            this.isNewUserClass = '';
            this.isActiveclients = false;  
            this.isEdition = false;
            this.isNewUser = false;
        },
        closeEdition(){  
            this.showHidePrintOption = false;
            this.isEdition = false;
            this.isNewUser = false;
            this.isNewUserClass = 'd-none';
            this.isActiveclients = true;  
            this.tabList= 'user-information';
            this.findUserInfo();
        },
        async findCountries(){
            var payload = {
                action: 'find-countries',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host      
            }
            await axios.post('/index.php', payload)
            .then(result => {
                try{
                    document.querySelector("[attr-id='userCountry']").innerHTML = '';
                    var option = document.createElement("option");
                    option.value = '';
                    option.text = 'Seleccionar';
                    option.defaultSelected = true;
                    document.querySelector("[attr-id='userCountry']").add(option);
                    let sum = 0;
                    Object.keys(result.data).forEach(key => {
                        var option = document.createElement("option");
                        option.value = result.data[sum].id;
                        option.text = result.data[sum].name;   
                        if(this.userCountry == result.data[sum].id){
                            option.defaultSelected = true;
                            document.querySelector("[attr-id='userCountry']").add(option);
                        }else{
                            document.querySelector("[attr-id='userCountry']").add(option);
                        }         
                        sum++;
                    });  
                    this.findStates();
                }catch(e){

                }
            });
        },
        async findStates(){ 
            var payload = {
                action: 'find-states',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                userCountry: this.userCountry,      
            }
            await axios.post('/index.php', payload)
            .then(result => {
                try{
                    document.querySelector("[attr-id='userState']").innerHTML = '';
                    var option = document.createElement("option");
                    option.value = '';
                    option.text = 'Seleccionar';
                    option.defaultSelected = true;
                    document.querySelector("[attr-id='userState']").add(option);
                    let sum = 0;
                    Object.keys(result.data).forEach(key => {
                        var option = document.createElement("option");
                        option.value = result.data[sum].id;
                        option.text = result.data[sum].name;
                        if(this.userState == result.data[sum].id){
                            option.defaultSelected = true;
                            document.querySelector("[attr-id='userState']").add(option);
                        }else{
                            document.querySelector("[attr-id='userState']").add(option);
                        }         
                        sum++;
                    });  
                    this.findCities();
                }catch(e){

                }
            });
        },
        async findCities(){ 
            var payload = {
                action: 'find-cities',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                userState: this.userState,      
            }
            await axios.post('/index.php', payload)
            .then(result => {
                try{
                    document.querySelector("[attr-id='userCity']").innerHTML = '';
                    var option = document.createElement("option");
                    option.value = '';
                    option.text = 'Seleccionar';
                    option.defaultSelected = true;
                    document.querySelector("[attr-id='userCity']").add(option);
                    let sum = 0;
                    Object.keys(result.data).forEach(key => {
                        var option = document.createElement("option");
                        option.value = result.data[sum].id;
                        option.text = result.data[sum].name;
                        if(this.userCity == result.data[sum].id){
                            option.defaultSelected = true;
                            document.querySelector("[attr-id='userCity']").add(option);
                        }else{
                            document.querySelector("[attr-id='userCity']").add(option);
                        }                 
                        sum++;
                    }); 
                }catch(e){

                }   
            });
        }, 
        phoneNumber(isPhone, userPhone){
            this.isPhone = isPhone;
            this.userPhone = userPhone;
        },
        async addContact(){  
            this.showHidePrintOption = false;
            var elems = document.querySelectorAll(".bad");
            [].forEach.call(elems, function(el) {
                el.classList.remove("bad");
            });
            this.errorText = '';
            this.loading = true;
            this.disabled = true;
            if(this.isEdition == true){
                 var payload = {
                    action: 'update-contact',
                    browserCountry: this.$route.params.browserCountry,
                    userLang: this.$route.params.userLang,
                    urlcode: window.location.host,
                    userFirstName: this.userFirstName,
                    userLastName: this.userLastName,
                    userPhone: this.userPhone,
                    userCountry: this.userCountry,
                    userState: this.userState,
                    userCity: this.userCity,
                    userStreet: this.userStreet,
                    userFloor: this.userFloor,
                    userDepto: this.userDepto,
                    userPObox: this.userPObox,
                    userGender: this.userGender,
                    userBirthDate: this.userYear + '-' + this.userMonth + '-' + this.userDay,
                    userMonth: this.userMonth,
                    userDay: this.userDay,
                    userMail: this.userMail,
                    obraSocial: this.obraSocial,
                    numObraSocial: this.numObraSocial,
                    ref: this.userSelected, 
                    dataReceiver: this.dataReceiver   
                }
            }else{
                 var payload = {
                    action: 'add-contact',
                    browserCountry: this.$route.params.browserCountry,
                    userLang: this.$route.params.userLang,
                    urlcode: window.location.host,        
                    userFirstName: this.userFirstName,
                    userLastName: this.userLastName,
                    userPhone: this.userPhone,
                    userMail: this.userMail,  
                    timezone: this.localZone,
                    userCountry: this.userCountry,
                    userState: this.userState,
                    userIdentify: this.userIdentify, 
                    dataReceiver: this.dataReceiver     
                }

            }
            if(this.userPhone == ''){
                this.errorText = 'Debes ingresar el teléfono del consultante.';   
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }	
                this.loading = false;
                this.disabled = false;
                return;
            }
            if(this.isPhone == 0 && this.userPhone != ''){
                this.errorText = 'El teléfono ingresado no es valido.';     
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }	
                this.loading = false;
                this.disabled = false;
                return;
            }
            
            await axios.post('/index.php', payload)
            .then(result => {
                this.loading = false;
                this.disabled = false;
                if(result.data.status == '200'){
                    if(this.isEdition == false){
                        this.userSelected = result.data.userCode;
                        this.findContacts(); 
                    }
                    this.findContacts(); 
                    this.isNewUserClass = 'd-none';
                    this.isEdition = false;
                    this.isNewUser = false;
                    this.isActiveclients = true;  
                    this.tabList= 'user-information';
                    this.findUserInfo();
                    this.errorText = 'Datos Actualizados.';    
                    this.toastBg = 'bg-success';
                    this.toastColor = 'text-dark';
                    this.toastNumber++;
                    var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                    try{
                        document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                        var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                        var bsAlert = new Toast(myAlert);//inizialize it
                        bsAlert.show();//show it
                    }catch(e){

                    }		
                    return;
                }else if(result.data.status == '400'){
                    if(result.data.error == 'E2'){
                        this.errorText = 'Debes ingresar un email de contacto.';    
                        document.querySelector("[attr-id='userMail']").classList.add("bad");
                        document.querySelector("[attr-id='userMail']").select();
                    }else if(result.data.error == 'E3'){
                        this.errorText = 'El email ingresado no parece ser vlido.';
                        document.querySelector("[attr-id='userMail']").classList.add("bad");
                        document.querySelector("[attr-id='userMail']").select();
                    }else if(result.data.error == 'E4'){
                        this.errorText = 'No puedes utilizar ese email.';
                        document.querySelector("[attr-id='userMail']").classList.add("bad");
                        document.querySelector("[attr-id='userMail']").select();
                    }else if(result.data.error == 'E5'){
                        this.errorText = 'El mail ingresado ya se encuentra registrado.';
                        document.querySelector("[attr-id='userMail']").classList.add("bad");
                        document.querySelector("[attr-id='userMail']").select();
                    }else if(result.data.error == 'E10'){
                        this.errorText = 'Debes ingresar el nombre.';
                        document.querySelector("[attr-id='userName']").classList.add("bad");
                        document.querySelector("[attr-id='userName']").select();
                    }else if(result.data.error == 'E11'){
                        this.errorText = 'El nombre no puede ser inferior a 1 caracter ni superar los 50 caracteres.';
                        document.querySelector("[attr-id='userName']").classList.add("bad");
                        document.querySelector("[attr-id='userName']").select();
                    }else if(result.data.error == 'E12'){
                        this.errorText = 'El nombre solo puede estar formado por caracteres de la [A a la Z].';
                        document.querySelector("[attr-id='userName']").classList.add("bad");
                        document.querySelector("[attr-id='userName']").select();
                    }else if(result.data.error == 'E13'){
                        this.errorText = 'Debes ingresar el apellido.';
                        document.querySelector("[attr-id='userLastName']").classList.add("bad");
                        document.querySelector("[attr-id='userLastName']").select();
                    }else if(result.data.error == 'E14'){
                        this.errorText = 'El apellido no puede ser inferior a 1 caracter ni superar los 50 caracteres.';
                        document.querySelector("[attr-id='userLastName']").classList.add("bad");
                        document.querySelector("[attr-id='userLastName']").select();
                    }else if(result.data.error == 'E15'){
                        this.errorText = 'El apellido solo puede estar formado por caracteres [A a la Z].';
                        document.querySelector("[attr-id='userLastName']").classList.add("bad");
                        document.querySelector("[attr-id='userLastName']").select();
                    }else if(result.data.error == 'E20'){
                        this.errorText = 'Debes seleccionar el país.';
                        document.querySelector("[attr-id='userCountry']").classList.add("bad");       
                    }else if(result.data.error == 'E30'){
                        this.errorText = 'Ya tienes cargado el contacto. Seleccionalo de tu lista de contactos.';
                        
                    }else if(result.data.error == 'E29'){
                        this.errorText = 'Debes ingresar la dirección.';
                        document.querySelector("[attr-id='userStreet']").classList.add("bad");  
                        document.querySelector("[attr-id='userStreet']").select();  
                    }else if(result.data.error == 'E30a'){
                        this.errorText = 'La dirección no puede tener un mínimo de 3 caracteres ni un máximo de 250.';
                        document.querySelector("[attr-id='userStreet']").classList.add("bad"); 
                        document.querySelector("[attr-id='userStreet']").select();  
                    }else if(result.data.error == 'E31'){
                        if(this.isEdition == true){
                            this.errorText = 'La dirección solo puede contener caracteres alfanuméricos.';
                        }else{
                            this.errorText = 'Ya tienes cargado el contacto con este mail. Seleccionalo de tu lista de contactos.';
                        }
                        document.querySelector("[attr-id='userStreet']").classList.add("bad"); 
                        document.querySelector("[attr-id='userStreet']").select();  
                    }else if(result.data.error == 'E33'){
                        this.errorText = 'Solo se aceptan números y letras para el piso.';
                        document.querySelector("[attr-id='userFloor']").classList.add("bad"); 
                        document.querySelector("[attr-id='userFloor']").select();  
                    }else if(result.data.error == 'E34'){
                        this.errorText = 'El número de piso no puede tener un mínimo de 1 caracter ni un máximo de 3.';
                        document.querySelector("[attr-id='userFloor']").classList.add("bad"); 
                        document.querySelector("[attr-id='userFloor']").select(); 
                    }else if(result.data.error == 'E36'){
                        this.errorText = 'Solo se aceptan números y letras para el departamento.';
                        document.querySelector("[attr-id='userDepto']").classList.add("bad");   
                        document.querySelector("[attr-id='userDepto']").select();   
                    }else if(result.data.error == 'E37'){
                        this.errorText = 'El número de departamento no puede tener un mínimo de 1 caracter ni un máximo de 8.'; 
                        document.querySelector("[attr-id='userDepto']").classList.add("bad"); 
                        document.querySelector("[attr-id='userDepto']").select(); 
                    }else if(result.data.error == 'E16'){
                        this.errorText = 'Debes ingresar la fecha de nacimiento.';
                        document.querySelector("[attr-id='userYear']").classList.add("bad");   
                        document.querySelector("[attr-id='userMonth']").classList.add("bad");   
                        document.querySelector("[attr-id='userDay']").classList.add("bad");   
                    }else if(result.data.error == 'E17'){
                        this.errorText = 'La fecha de nacimiento no es valida.';
                        document.querySelector("[attr-id='userYear']").classList.add("bad");   
                        document.querySelector("[attr-id='userMonth']").classList.add("bad");   
                        document.querySelector("[attr-id='userDay']").classList.add("bad");   
                    }else if(result.data.error == 'E18'){
                        this.errorText = 'La fecha de nacimiento no es valida.';
                        document.querySelector("[attr-id='userYear']").classList.add("bad");   
                        document.querySelector("[attr-id='userMonth']").classList.add("bad");   
                        document.querySelector("[attr-id='userDay']").classList.add("bad");   
                    }else if(result.data.error == 'E19'){
                        this.errorText = 'El consultante debe ser mayor de edad.';
                        document.querySelector("[attr-id='userYear']").classList.add("bad");   
                        document.querySelector("[attr-id='userMonth']").classList.add("bad");   
                        document.querySelector("[attr-id='userDay']").classList.add("bad");   

                    }else if(result.data.error == 'E50'){
                        this.errorText = 'El nombre de la obra social o prepaga no puede superar los 150 caracteres.';
                        document.querySelector("[attr-id='obraSocial']").classList.add("bad");     
                    }else if(result.data.error == 'E51'){
                        this.errorText = 'El número de afiliado de la obra social o prepaga no puede superar los 150 caracteres.';
                        document.querySelector("[attr-id='numObraSocial']").classList.add("bad");  
                    }else if(result.data.error == 'E23'){
                        this.errorText = 'Debes seleccionar tu provincia o estado.';
                        document.querySelector("[attr-id='userState']").classList.add("bad"); 
                        this.userState = '';
                        this.userCity = '';
                    }else if(result.data.error == 'E24'){
                        this.errorText = 'Debes seleccionar tu provincia o estado.';
                        document.querySelector("[attr-id='userState']").classList.add("bad"); 
                        this.userState = '';
                        this.userCity = '';
                    }else if(result.data.error == 'E25'){
                        this.errorText = 'Debes seleccionar tu provincia o estado.';
                        document.querySelector("[attr-id='userState']").classList.add("bad"); 
                        this.userState = '';
                        this.userCity = '';             
                    }   
                    this.toastBg = 'bg-danger';
                    this.toastColor = 'text-dark';
                    this.toastNumber++;
                    var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                    try{
                        document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                        var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                        var bsAlert = new Toast(myAlert);//inizialize it
                        bsAlert.show();//show it
                    }catch(e){

                    }		
                    return;
                }                        
            })
            .catch(error => {
                this.loading = false;
                this.disabled = false;
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }		
                return;

            })
        },
        openContact(to, toImg, toName, chatId){
            this.expandRecord();
            this.showHidePrintOption = false;
            try{
                document.querySelector('.menu-container').classList.add('hide');   
            } catch (error) {
            }
            try{
                document.querySelector('.ficha').classList.add('show');  
            } catch (error) {
            }
            
            this.isNewUserClass = 'd-none';
            this.isNewUser = false;
            this.isEdition = false;
            this.isActiveclients = true;  
            console.log('openFicha')  //importante para la app
            this.avatarTo = toImg;
            this.nameTo = toName;
            this.tabList= 'user-information';
            this.userSelected = to;
            this.chatId = chatId;
            this.findUserInfo();   
            this.listBilling(); 
        },
        
        async findUserInfo(){
            var payload = {
                action: 'find-user-info-contact',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.dataReceiver,
                ref: this.userSelected    
            }
            await axios.post('/index.php', payload)
            .then(result => {
                try{
                    document.querySelector('.clients-users').scrollTop = 0;    
                }catch(e){
                }
                 if(result.data.status == '200'){
                    this.userFirstName = result.data.userFirstName;
                    this.userLastName = result.data.userLastName;
                    this.userBirthDate = result.data.userBirthDate;

                    this.userAddress = result.data.userStreet + ' ' + result.data.userFloor + result.data.userDpto;
                    if(result.data.userPObox != ''){
                        this.userAddress = this.userAddress + ' (' + result.data.userPObox + ')';
                    }
                    if(result.data.userCity != '0'){
                        this.userAddress = this.userAddress + ' ' + result.data.cityText;
                    }
                    if(result.data.userState != '0'){
                        this.userAddress = this.userAddress + ' ' + result.data.stateText;
                    }
                    if(result.data.userCountry != '0'){
                        this.userAddress = this.userAddress + ' ' + result.data.countryText;
                    }

                    this.userCountry = result.data.userCountry;
                    this.userState = result.data.userState;
                    this.userCity = result.data.userCity;
                    this.userStreet = result.data.userStreet;
                    this.userFloor = result.data.userFloor;
                    this.userDpto = result.data.userDpto;
                    this.userPObox = result.data.userPObox;
                    this.userGender = result.data.userGender;
                    if(result.data.userGender == 1){
                        this.userGenderText = 'Hombre';
                    }else if(result.data.userGender == 2){
                        this.userGenderText = 'Mujer';
                    }else if(result.data.userGender == 3){
                        this.userGenderText = 'Transgenero';
                    }
                    this.userMail = result.data.userEmail;
                    this.userPhone = "+" + result.data.userPhone;
                    this.showPhone = result.data.userPhone;
                    this.isPhone = 1;
                    this.userYear = result.data.yBirth;
                    this.userMonth = result.data.mBirth;
                    this.userDay = result.data.dBirth;
                    this.userImg = result.data.userImg;   
                    this.numObraSocial = result.data.numObraSocial;
                    this.obraSocial = result.data.obraSocial; 
                    this.findNotes();                           
                 }  
            })
            .catch(error => {
                    this.loading = false;
                    this.disabled = false;
                    this.errorText = 'Revise su conexión de internet.';
                    this.toastBg = 'bg-danger';
                    this.toastColor = 'text-dark';
                    this.toastNumber++;
                    var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                    try{
                        document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                        var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                        var bsAlert = new Toast(myAlert);//inizialize it
                        bsAlert.show();//show it
                    }catch(e){

                    }		
                    return;
                })
        },
        editUserInfo(){
            this.showHidePrintOption = false;
            var elems = document.querySelectorAll(".bad");
            [].forEach.call(elems, function(el) {
                el.classList.remove("bad");
            });
            this.isNewUserClass = 'd-sm-flex';
            this.isNewUser = true;
            this.isEdition = true; 
            //this.isPhone = '';

            this.tabList= ''; 
            this.findCountries();
        },
        async findUserInformation(){
            this.isNewUserClass = 'd-none';
            this.isNewUser = false;
            this.isEdition = true;
            this.isActiveclients = true;  
            this.avatarTo = toImg;
            this.nameTo = toName;
            this.tabList= 'user-information';  
        },
        onInputficha(){
            this.ficha = document.querySelector('#fichaText').innerHTML;
        },
        async findContacts(){
            this.contacts = [];
            var payload = {
                action: 'find-contacts',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.dataReceiver,
                mode: 1,      
            }
            await axios.post('/index.php', payload)
            .then(result => {
                this.contacts = result.data; 
            });
        },
        async findContact(ref){
            var payload = {
                action: 'find-contacts',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.dataReceiver,
                mode: 1,
                ref: ref     
            }
            await axios.post('/index.php', payload)
            .then(result => {
                if(result.data.length > 0){
                    this.openContact(result.data[0].idSeller, result.data[0].imgSeller, result.data[0].sellerName, ref) 
                }
            });
        },  

        showContactsMenu(){
            this.contractRecord();
            try{
                document.querySelector('.clients-users').scrollTop = 0;    
            }catch(e){
            }
            document.querySelector('.menu-container').classList.remove('hide');
            document.querySelector('.ficha').classList.remove('show');
        }, 
        liveSearch(){
            this.showHidePrintOption = false;
            var s = this.searchContact.toLowerCase();
            var elems = '';
            if(s.length < 1){
                elems = document.querySelectorAll('.contact');
                [].forEach.call(elems, function(el) {
                    el.style.display = "flex";        
                });
            }else{
                elems = document.querySelectorAll('.contact');
                [].forEach.call(elems, function(el) {
                    el.style.display = "none";    
                });
                elems = document.querySelectorAll('[data-search-term *= "'+s+'"]');
                [].forEach.call(elems, function(el) {
                    el.style.display = "flex";      
                });
            }    
        },
        async findNotes(){
            this.loading = false;
            this.disabled = false;
            var payload = {
                action: 'find-notes',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.dataReceiver,
                ref: this.userSelected,  
            }
            await axios.post('/index.php', payload)
            .then(result => {
                this.notes = result.data.note;
                return;
            });
        },  
        async saveNotes(){
            this.loading = true;
            this.disabled = true;
            var payload = {
                action: 'update-notes',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.dataReceiver,
                ref: this.userSelected,
                note: this.notes     
            }
            await axios.post('/index.php', payload)
            .then(result => {
                this.loading = false;
                this.disabled = false;
                this.errorText = 'Se ha actualizado las notas del usuario.';
                this.toastBg = 'bg-success';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }		 
                return;
            });
        }, 
        reloadbooking(){
            this.bookingsEnd = 0;
            this.bookingsEndLast = 0;
            this.next = 0;
            this.filter = 0;
            this.nextLast = 0;
            this.bookingsLast = [];
            this.bookings = [];
            this.findBookingsNext();
            this.findBookingsLast();
        }, 
        findOtherBooking(val){ 
            try{
                var e = this;
                this.bookingId = ''; 
                setTimeout(function(){ 
                    e.bookingId = val;
                }, 500);
                this.bookingId = e.bookingId;  
            }catch(e){

            } 
        },
        showHidePlansOptions(){
            if(this.openOptionPlans == ''){
                this.openOptionPlans = 'open'
            }else{
                this.openOptionPlans = '';
                this.findUserData();
            }
        },
        goToAction(id, action){
            if(action == 'chat'){
                this.$router.push({ name: 'prof-chat', params: { ref: id }});
            }
            document.querySelector('html').style.overflow = 'auto';
        },
        async listBilling(){
            this.items = [];
            var payload = {
                    action: 'find-billing-all',
                    browserCountry: this.$route.params.browserCountry,
                    userLang: this.$route.params.userLang,
                    urlcode: window.location.host,
                    dataReceiver: this.dataReceiver,
                    mode: 1, 
                    export: false,
                    timezone: this.localZone,
                    userSelected: this.userSelected
                } 
                await axios.post('/index.php', payload)
                .then(result => { 
                    this.items = result.data;  
                    if(this.items.length > 0){
                        this.items.sort((a, b) => Number(new Date(b.dateBookingNoFormat)) - Number(new Date(a.dateBookingNoFormat)));
                    }
                })
                .catch(error => {
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }	
                return;

            })
        }, 	
    }  
}
</script>
<style scoped>
.screen-waiting-calendar{
    position: fixed;
    z-index: 5000000;
    text-align: center;
    background: #0d6efd;
    color: #fff;
}
.option-plans-popup{
    position: fixed;
    top: -100%;
    background: #bf4496;
    z-index: 10000;
    border-radius: 0 0 13px 13px;
    box-shadow: 0 8px 16px 0 rgb(0 0 0 / 5%), 0 0 6px 0 rgb(0 0 0 / 5%);
    padding-top: 0;
    transition: all;
    transition: all 0.4s ease-in-out;
    overflow: auto;
    padding: 0;
    width: 100%;
    height: calc(100% - 153px);
   
}
.option-plans-popup.open{
    top: 0;
}
.bookings-options .badge.active{
    background: #40cd51;
    margin-right: 10px;
}
.bookings-options .badge.paused{
    background-color: #ffd900 !important;
    color: #605e5e;
}
.w-fit-content{
    width: fit-content;
}
@media screen and (min-width: 720px) {
#editUserInfo{   
    margin-top: 0px !important;
}
}
.print-options{
    position: fixed;
    background: #fff;
    width: 300px;
    max-height: calc(100% - 132px);
    top: 55px;
    left: 18px;
    box-shadow: 0 0 10px rgb(0 0 0 / 56%) !important;
    border: 1px solid #ddd;
    overflow: auto;
    padding: 0px;
    border-radius: 5px;
    z-index: 500000;
}
@media screen and (max-width: 1024px) {
.print-options{
    left: 0;
}
}
@media screen and (max-width: 720px) {
.print-options{
    left: 0;
    width: 100%;
    /* height: calc(100% - 105px); */
    max-height: calc(100% - 105px);
}
}
.print-options a {
    text-decoration: none;
    color: #495057;
    margin-top: 10px;
    display: block;
}
.print-options a:hover {
    color: #8b9191;
}
</style>

<style>
.clients-users .bookings-options{
    height: 100%;
}
@media screen and (max-width: 720px) {
.clients-users .bookings-options{
    height: calc(100% - 65px);
}
}
.clients.clients-full {
    display: block;
    overflow: hidden;
    margin: 0 auto;
    box-shadow: none;
    top: 0;
    width: 100%;
    max-width: 1600px;
    height: 100%;
    background: #f2f3f8;
    transform: none;
    position: initial;
    z-index: 1;
}
.clients.clients-full {
    max-width: inherit;
}
.content-help-info .clients.clients-full .ficha{
    width: 100%;
}
.content-help.full .content-help-info .clients-container {
    position: relative;
    z-index: 100;
    width: 100%;
    height: 100%;
    overflow: hidden;
    top: 0;
}
</style>